import * as defaults from './defaults'
import PropTypes from 'prop-types'
import Preview from './preview'
import Sidebar from './sidebar'
import Canvas from './canvas'
import React from 'react'

class MBlocksDesigner extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    active: PropTypes.object,
    changes: PropTypes.number,
    config: PropTypes.object,
    defaultValue: PropTypes.object,
    editable: PropTypes.bool,
    email: PropTypes.object,
    endpoint: PropTypes.string,
    program: PropTypes.object,
    settings: PropTypes.bool,
    status: PropTypes.string,
    title: PropTypes.string,
    tokens: PropTypes.array,
    onAdd: PropTypes.func,
    onChange: PropTypes.func,
    onClone: PropTypes.func,
    onEdit: PropTypes.func,
    onMove: PropTypes.func,
    onRemove: PropTypes.func,
    onSetConfig: PropTypes.func,
    onSetStatus: PropTypes.func,
    onUpdate: PropTypes.func
  }

  static defaultProps = {
    editable: true
  }

  _handleSave = this._handleSave.bind(this)

  render() {
    const { editable } = this.props
    return (
      <div className="designer">
        <div className="designer-main">
          <Preview>
            <Canvas { ...this._getCanvas() } />
          </Preview>
        </div>
        { editable &&
          <div className="designer-sidebar">
            <Sidebar { ...this._getSidebar() } />
          </div>
        }
      </div>
    )
  }

  componentDidMount() {
    const defaultValue = this.props.defaultValue || this._getDefault()
    this.props.onSetConfig(defaultValue)
  }

  _getCanvas() {
    const { active, config, editable, onAdd, onClone, onEdit, onMove, onRemove } = this.props
    return {
      active,
      config,
      editable,
      onAdd,
      onClone,
      onEdit,
      onMove,
      onRemove
    }
  }

  _getDefault() {
    return {
      page: defaults.page,
      sections: []
    }
  }

  _getSidebar() {
    const { active, changes, config, email, program, settings, status, tokens, onEdit, onUpdate } = this.props
    return {
      active,
      changes,
      config,
      email,
      settings,
      status,
      program_id: program ? program.id : null,
      tokens,
      onEdit,
      onUpdate,
      onSave: this._handleSave
    }
  }

  _handleSave(config) {
    const { endpoint } = this.props
    this.props.onSetStatus('saving')
    this.context.network.request({
      endpoint,
      method: 'PATCH',
      body: {
        config
      },
      onSuccess: ({ data }) => {
        this.props.onSetStatus('ready')        
      },
      onFailure: () => {}
    })

  }

}

export default MBlocksDesigner
